import React, { Component } from 'react'
import {
  extendParentClass,
  extendBaseClass,
} from '../../../../../../utils/classes'

export class Item extends Component {
  baseClass = extendParentClass.bind(this)('item')

  extend = extendBaseClass.bind(this)

  render() {
    const { url, label, title } = this.props
    const linkClass = this.extend('link')
    return (
      <li>
        <div>
          Icons made by{' '}
          <a href={url} title={title} className={linkClass}>
            {label || title}
          </a>{' '}
          from{' '}
          <a
            href="https://www.flaticon.com/"
            title="Flaticon"
            className={linkClass}
          >
            www.flaticon.com
          </a>
        </div>
      </li>
    )
  }
}

export default Item
